export default __webpack_public_path__ + "static/media/img_3.555125ea.JPG";